/**
 * @class Infra3DSDKError
 *
 * @classdesc Generic Infra3DSDK error.
 */
export class Infra3DSDKError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, Infra3DSDKError.prototype);
        this.name = "Infra3DSDKErrorError";
    }
}
//# sourceMappingURL=Infra3DSDKError.js.map